{
  "_provenance": {
    "ns": "copy",
    "source": "the staff-editable family copy store, keyed by slot id — read for non-English locales (brief B8, R3-B17) (#2109 R3 lane L9)"
  },
  "apply": {
    "code_typo": {
      "headline": "That code has a typo in it.",
      "lede": "The code you entered is one or two characters off — codes are easy to mishear and easy to mistype. Check it against what you were given and try again, or carry on without it and tell us who referred you.",
      "meta_that_code_key": "That code",
      "meta_that_code_value": "Has a typo",
      "meta_what_to_do_key": "What to do",
      "meta_what_to_do_value": "Check it and try again",
      "point_contact_trf": "Not sure who that is, or don’t have one yet? Reach the Tyler Robinson Foundation team directly at <a>trf.org/get-support</a> — they can help you sort out the code",
      "point_social_worker": "Ask your hospital social worker or TRF to read the code back to you again"
    },
    "cycle_closed": {
      "headline": "This year’s applications are closed.",
      "lede": "The application window for this cycle has ended. Nothing is wrong with your code — it was for a round that has now closed. Your hospital social worker or the TRF team can tell you when the next one opens.",
      "meta_this_round_key": "This round",
      "meta_this_round_value": "Closed",
      "meta_what_to_do_key": "What to do",
      "meta_what_to_do_value": "Wait for the next round",
      "point_contact_trf": "Not sure who that is, or don’t have one yet? Reach the Tyler Robinson Foundation team directly at <a>trf.org/get-support</a> — they can tell you when the next round opens",
      "point_social_worker": "Your hospital social worker or the TRF team can tell you when the next round opens"
    },
    "definition_gate": {
      "unavailable_body": "Nothing you’ve entered has been lost. Please try again — if it keeps happening, get in touch and we’ll help you finish by another route."
    },
    "documents": {
      "added_by_trf": "TRF added this for you",
      "cap_toast_title": "Some files were not added",
      "hint_bill_statement": "Recent bills — rent, utilities, medical or other — up to 5",
      "hint_child_photo": "A recent photo of your child — add up to 3",
      "hint_diagnosis_letter": "From your care team",
      "hint_family_photo": "Your child with family or siblings — add up to 3",
      "hint_income_verification": "A recent paystub"
    },
    "invite_invalid": {
      "headline": "This link is <em>no longer valid</em>.",
      "lede": "This link or code may already have been used, or it may have been turned off or replaced with a newer one. Nothing is wrong on your end — it just takes one quick ask to fix.",
      "meta_this_link_key": "This link",
      "meta_this_link_value": "No longer valid",
      "meta_what_to_do_key": "What to do",
      "meta_what_to_do_value": "Ask for a fresh link",
      "point_contact_trf": "Not sure who that is, or don’t have one yet? Reach the Tyler Robinson Foundation team directly at <a>trf.org/get-support</a> — they can help you sort out a fresh link or code",
      "point_nothing_lost": "A new link opens this same application — nothing you did is lost",
      "point_social_worker": "Ask your hospital social worker for a fresh TRF application link or code"
    },
    "invite_required": {
      "code_entry_accepted": "Code accepted — it will be applied to your application.",
      "code_entry_error_invalid": "That code isn’t valid — check with the person who gave it to you.",
      "code_entry_eyebrow": "Have an application code?",
      "code_entry_field_label": "Application code",
      "code_entry_helper": "If your social worker or a TRF team member gave you a code, enter it here.",
      "code_entry_submit": "Continue",
      "headline": "This application opens <em>by referral</em>.",
      "lede": "To make sure every family gets the care and attention they deserve, TRF applications currently begin with a personal invitation. You don’t need to do anything complicated — the right link is one conversation away.",
      "meta_how_to_apply_key": "How to apply",
      "meta_how_to_apply_value": "By referral",
      "meta_who_can_refer_key": "Who can refer",
      "meta_who_can_refer_value": "Your hospital social worker or TRF",
      "point_contact_trf": "Not sure who that is, or don’t have one yet? Reach the Tyler Robinson Foundation team directly at <a>trf.org/get-support</a> — they can point you to the right hospital contact and get the referral started",
      "point_ready": "Your link or code opens this same application — ready when you are",
      "point_social_worker": "Ask your hospital social worker for a TRF application link or code"
    },
    "invite_stop": {
      "alternate_link_label": "Sign in",
      "alternate_prompt": "Already started?",
      "document_label": "Apply to TRF",
      "eyebrow": "— Apply to TRF",
      "footer_attribution": "A program of the Tyler Robinson Foundation"
    },
    "new_families_soon": {
      "headline": "Applications for new families open soon.",
      "lede": "Right now this round is open to families renewing their TRF grant. New families can start an application from the date shown here. If you are renewing, open the link TRF sent you or enter your code.",
      "meta_opens_key": "New families from",
      "meta_this_round_key": "This round",
      "meta_this_round_value": "Renewing families",
      "point_contact_trf": "Questions before then? Reach the Tyler Robinson Foundation team at <a>trf.org/get-support</a>"
    },
    "renewal": {
      "card_heading": "Renew your Signature Grant",
      "error_line": "Couldn’t load your renewal status. Please refresh to try again.",
      "invite_line": "Year 2+ families can request a Signature Grant renewal. We’ll pre-fill what we already know.",
      "request_title": "Renewal request",
      "request_title_with_year": "{{year}} renewal request",
      "status_submitted": "Submitted — your TRF team is reviewing it",
      "status_under_review": "Under review"
    },
    "review": {
      "heading": "Check your answers",
      "intro": "This is everything you told us. Read it over before you agree and submit.",
      "retired_heading": "Questions we no longer ask",
      "retired_note": "You answered these earlier. We no longer ask them, and your answers stay on file."
    },
    "status": {
      "body": "A TRF case manager will review your application. We’ll reach out if we need anything else, and we’ll be in touch when a decision is made.",
      "body_acceptance_recorded": "TRF has recorded that you accept. We’re setting up your family’s account and your grant now.",
      "body_admitted": "Welcome to TRF. Your family’s account is ready, and your grant is on your Grants page.",
      "body_admitted_renewal": "Your renewal is approved. Your family’s account is ready, and your grant is on your Grants page.",
      "body_approved": "Your application has been approved. Someone from TRF will be in touch about what happens next.",
      "body_denied": "TRF has emailed you about your application. If you can’t find the email, please contact the TRF team.",
      "body_needs_info": "Your TRF case manager asked about the items listed below. Open your application, update them, and send it again. We’ll keep reviewing it as soon as it’s back.",
      "body_offer_sent": "Your application has been approved. Someone from TRF will contact you to confirm that you accept. Nothing else is needed from you until then.",
      "body_offer_sent_renewal": "Your renewal has been approved. Someone from TRF will contact you to confirm that you accept. Nothing else is needed from you until then.",
      "body_waitlisted": "TRF has emailed you about your application. If you can’t find the email, please contact the TRF team.",
      "decision_note_label": "Note from TRF",
      "documents_attribution": "From your TRF case manager:",
      "documents_reassurance": "Everything else you sent is saved — you only need to add what’s listed above.",
      "eyebrow": "Application received",
      "eyebrow_decided": "Your application",
      "grants_cta": "See your grant",
      "headline": "It’s in our hands now.",
      "headline_admitted": "You’re in.",
      "headline_admitted_renewal": "Welcome back.",
      "headline_approved": "Good news.",
      "headline_denied": "Your application has been reviewed.",
      "headline_needs_info": "TRF needs something from you.",
      "headline_waitlisted": "Your application has been reviewed.",
      "needs_info_cta": "Continue your application",
      "needs_info_label": "We need a bit more from you",
      "submitted_prefix": "Submitted {{date}}",
      "timeline_decision": "Decision",
      "timeline_review": "Under review",
      "timeline_submitted": "Submitted"
    },
    "wizard": {
      "phi_gate": {
        "eyebrow": "Before we ask about care",
        "title": "About your child’s health"
      },
      "publicity": {
        "eyebrow": "Optional",
        "title": "Photos and stories"
      },
      "region_step": {
        "error_body": "We weren’t able to reach TRF to load the right version of this step for your region, so we haven’t shown you one. Nothing has been recorded, and every answer you’ve given is saved. Please check your connection and try again — if it keeps failing, contact TRF and we’ll take it from there.",
        "error_eyebrow": "This step didn’t load",
        "error_retry": "Try again",
        "error_title": "We couldn’t load this step",
        "error_toast_body": "Your answers are saved. Check your connection and try again — nothing has been recorded for this step.",
        "loading_body": "Loading this step for your region.",
        "loading_eyebrow": "Just a moment"
      }
    }
  }
}
